import React from 'react'
import { Grid, Typography } from '@mui/material'
import LayoutContainer from 'src/components/common/containers/LayoutContainer'
import InputTextField from 'src/components/common/form-elements/InputTextField'
import FloCheckbox from 'src/components/common/form-elements/FloCheckbox'
import SaveNotification from 'src/components/common/SaveNotification'
import { LoyaltyFieldDef, RewardsProvider } from 'src/lib/types/integrations'
import { useLoyaltyConfig } from './useLoyaltyConfig'

const LABEL = 'eRewards'

const FIELDS: LoyaltyFieldDef[] = [
  { key: 'e_rewards_merchant_id', label: 'Merchant ID', isRequired: true },
  { key: 'e_rewards_customer_key', label: 'Customer Key', isRequired: true }
]

const ERewards = () => {
  const { config, settingsUpdated, errorFields, setActive, setFieldValue, clearFieldError, handleSave, handleDiscard } =
    useLoyaltyConfig(RewardsProvider.E_REWARDS, LABEL, FIELDS)

  return (
    <>
      <LayoutContainer>
        <Grid item xs={12} md={12} display={'flex'} alignItems={'center'}>
          <Grid container>
            <Grid item xs={10} md={11} display={'flex'} alignItems={'center'}>
              <Typography variant='body2'>{LABEL} is</Typography>
              <Typography variant='body1' sx={{ fontWeight: 500, marginLeft: 2 }}>
                {config.isActive ? 'enabled' : 'disabled'}
              </Typography>
            </Grid>
            <Grid item xs={2} md={1} display={'flex'} alignItems={'center'} justifyContent={'end'}>
              <FloCheckbox
                value={config.isActive}
                setValue={setActive}
                name='ERewardsToggle'
                label={`Enable ${LABEL}`}
                type='SWITCH'
              />
            </Grid>
          </Grid>
        </Grid>
      </LayoutContainer>

      <LayoutContainer heading={LABEL}>
        <div className='w-full py-3'>
          <div className='flex flex-col gap-4'>
            {FIELDS.map(field => (
              <InputTextField
                key={field.key}
                textFieldId={field.key}
                label={field.label}
                isRequired={field.isRequired !== false}
                inputType='text'
                inputValue={config.metadata[field.key] ?? ''}
                handleChange={(e: React.ChangeEvent<HTMLInputElement>) => setFieldValue(field.key, e.target.value)}
                errorStatus={errorFields.includes(field.key)}
                customErrorMessage=''
                handleFocus={() => clearFieldError(field.key)}
              />
            ))}
          </div>
        </div>
      </LayoutContainer>

      <SaveNotification isVisible={settingsUpdated} onSave={handleSave} onDiscard={handleDiscard} className='w-full' />
    </>
  )
}

export default ERewards
